export default function convertLocale(locale) {
  switch (locale) {
    case "en":
      return 'x-default';
    case "cn":
      return 'zh'
    default:
      return locale;
  }
}
